export default __webpack_public_path__ + "static/media/detail_mobile_10_5.aa9a7e22.jpg";